import axios from "axios";

const isInForeground = () => document.visibilityState === 'visible';

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const MAX_RETRIES = 3;

const apiTwilio = axios.create({
  baseURL: process.env.REACT_APP_URL_API,
  headers: {
    "content-type": "application/json",
  },
});

apiTwilio.interceptors.request.use(async (config) => {
  if (!navigator.onLine) {
    return Promise.reject({ message: 'Sem conexão com a internet', code: 'NO_CONNECTION' });
  }

  if (!isInForeground()) {
    await new Promise((resolve) => {
      const handleVisibilityChange = () => {
        if (isInForeground()) {
          document.removeEventListener('visibilitychange', handleVisibilityChange);
          resolve();
        }
      };
      document.addEventListener('visibilitychange', handleVisibilityChange);
    });
  }

  config.headers.Authorization = process.env.REACT_APP_TOKEN_SMS_TWILIO;
  config.headers["X-User-Agent"] = "WebConsumer";

  return config;
});

apiTwilio.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;

    const isNetworkError = !error.response || error.code === 'ECONNABORTED' || error.message === 'Network Error';

    if (isNetworkError) {
      config.__retryCount = config.__retryCount || 0;

      if (config.__retryCount >= MAX_RETRIES) {
        return Promise.reject(error);
      }

      config.__retryCount += 1;
      await delay(1000 * config.__retryCount);

      if (!navigator.onLine) {
        return Promise.reject({ message: 'Sem conexão na tentativa de retry', code: 'NO_CONNECTION' });
      }

      if (!isInForeground()) {
        await new Promise((resolve) => {
          const handleVisibilityChange = () => {
            if (isInForeground()) {
              document.removeEventListener('visibilitychange', handleVisibilityChange);
              resolve();
            }
          };
          document.addEventListener('visibilitychange', handleVisibilityChange);
        });
      }
      return apiTwilio(config);
    }
    return Promise.reject(error);
  }
);

export default {
  apiTwilio,
};
